// apps/web/src/router.tsx
// React Router DOM v6 路由定义 — Phase 2 完整版

import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@stores/authStore";
import LoginPage from "@pages/LoginPage";
import RegisterPage from "@pages/RegisterPage";
import HomePage from "@pages/HomePage";
import BankListPage from "@pages/BankListPage";
import CreateBankPage from "@pages/CreateBankPage";
import BankDetailPage from "@pages/BankDetailPage";
import QuestionDetailPage from "@pages/QuestionDetailPage";
import QuestionEditPage from "@pages/QuestionEditPage";
import PracticePage from "@pages/PracticePage";
import TypePracticePage from "@pages/TypePracticePage";
import ImportPage from "@pages/ImportPage";
import ImportHistoryPage from "@pages/ImportHistoryPage";
import WrongQuestionsPage from "@pages/WrongQuestionsPage";
import FavoritesPage from "@pages/FavoritesPage";
import NotesPage from "@pages/NotesPage";
import NoteDetailPage from "@pages/NoteDetailPage";
import ProfilePage from "@pages/ProfilePage";
import SearchPage from "@pages/SearchPage";
import NotFoundPage from "@pages/NotFoundPage";

// 受保护路由包装器（Phase 1 实现）
function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* 公开路由 */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* 首页 */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <HomePage />
          </RequireAuth>
        }
      />

      {/* 题库列表 */}
      <Route
        path="/banks"
        element={
          <RequireAuth>
            <BankListPage />
          </RequireAuth>
        }
      />

      {/* 新建题库 */}
      <Route
        path="/banks/new"
        element={
          <RequireAuth>
            <CreateBankPage />
          </RequireAuth>
        }
      />

      {/* 题库详情 */}
      <Route
        path="/banks/:bankId"
        element={
          <RequireAuth>
            <BankDetailPage />
          </RequireAuth>
        }
      />

      {/* 添加题目 */}
      <Route
        path="/banks/:bankId/questions/new"
        element={
          <RequireAuth>
            <QuestionEditPage />
          </RequireAuth>
        }
      />

      {/* 题目详情 */}
      <Route
        path="/banks/:bankId/questions/:qid"
        element={
          <RequireAuth>
            <QuestionDetailPage />
          </RequireAuth>
        }
      />

      {/* 编辑题目 */}
      <Route
        path="/banks/:bankId/questions/:qid/edit"
        element={
          <RequireAuth>
            <QuestionEditPage />
          </RequireAuth>
        }
      />

      {/* 练习页 */}
      <Route
        path="/banks/:bankId/practice/type-select"
        element={
          <RequireAuth>
            <TypePracticePage />
          </RequireAuth>
        }
      />

      <Route
        path="/banks/:bankId/practice/:mode"
        element={
          <RequireAuth>
            <PracticePage />
          </RequireAuth>
        }
      />

      {/* 导入页 */}
      <Route
        path="/import"
        element={
          <RequireAuth>
            <ImportPage />
          </RequireAuth>
        }
      />

      {/* 导入生成记录 */}
      <Route
        path="/import/history"
        element={
          <RequireAuth>
            <ImportHistoryPage />
          </RequireAuth>
        }
      />

      {/* 错题本 */}
      <Route
        path="/wrong"
        element={
          <RequireAuth>
            <WrongQuestionsPage />
          </RequireAuth>
        }
      />

      {/* 收藏 */}
      <Route
        path="/favorites"
        element={
          <RequireAuth>
            <FavoritesPage />
          </RequireAuth>
        }
      />

      {/* 笔记 */}
      <Route
        path="/notes"
        element={
          <RequireAuth>
            <NotesPage />
          </RequireAuth>
        }
      />

      {/* 笔记详情 */}
      <Route
        path="/notes/:noteId"
        element={
          <RequireAuth>
            <NoteDetailPage />
          </RequireAuth>
        }
      />

      {/* 个人中心 */}
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <ProfilePage />
          </RequireAuth>
        }
      />

      {/* 搜索 */}
      <Route
        path="/search"
        element={
          <RequireAuth>
            <SearchPage />
          </RequireAuth>
        }
      />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
